import { LoaderRow } from "@circle-react/components/shared/LoaderRow";
import { toLocaleString } from "@circle-react/helpers/number";
import type { Comment } from "@circle-react/types/Comment";
import { Modal } from "@circleco/compass/components/Modal";
import InfiniteScroll from "react-infinite-scroll-component";

import { t } from "@/i18n-js/instance";

import { MemberRow } from "./MemberRow";
import { useLikesList } from "./useLikesList";

interface LikesModalComponentProps {
  comment: Comment;
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const LikesModalComponent = ({
  comment,
  open,
  onOpenChange,
}: LikesModalComponentProps) => {
  const { members, totalCount, isInitialLoading, hasNextPage, fetchNextPage } =
    useLikesList({ comment });
  const likesCount = totalCount ?? comment.likes_count;

  const title = t("comments.likes", {
    count: likesCount,
    formatted_count: toLocaleString(likesCount),
  });
  const scrollableTargetId = `comment-likes-modal-${comment.id}`;

  return (
    <Modal.Root open={open} onOpenChange={onOpenChange} size="md">
      <Modal.Content>
        <Modal.Header title={title} />
        <Modal.Body customLayout>
          {isInitialLoading ? (
            <LoaderRow />
          ) : (
            <div
              id={scrollableTargetId}
              className="overflow-y-auto sm:max-h-80"
            >
              <InfiniteScroll
                dataLength={members.length}
                next={fetchNextPage}
                hasMore={hasNextPage ?? false}
                loader={<LoaderRow />}
                scrollableTarget={scrollableTargetId}
                scrollThreshold={0.75}
                className="flex flex-col space-y-4"
              >
                {members.map(communityMember => (
                  <MemberRow
                    key={communityMember.id}
                    communityMember={communityMember}
                    onNavigate={() => onOpenChange(false)}
                  />
                ))}
              </InfiniteScroll>
            </div>
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
